import { render } from "./SendEmailModal.vue?vue&type=template&id=58ec1046&scoped=true&ts=true"
import script from "./SendEmailModal.vue?vue&type=script&lang=ts"
export * from "./SendEmailModal.vue?vue&type=script&lang=ts"

import "./SendEmailModal.vue?vue&type=style&index=0&id=58ec1046&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ec1046"]])

export default __exports__